import axios, {AxiosInstance} from 'axios';

const api = process.env.VUE_APP_DATA_SUBMISSION_URL!;

const axiosInstance: AxiosInstance = axios.create({
    baseURL: api,
});

export default axiosInstance;
